// UI string dictionary. English is the source of truth used for auto-translation.
export const en = {
  // nav
  "nav.match": "Match",
  "nav.friends": "Friends",
  "nav.flashcards": "Flashcards",
  "nav.profile": "Profile",
  "nav.moderation": "Moderation",
  "nav.login": "Log in",
  "nav.signup": "Get started",
  "nav.points": "pts",
  // landing
  "landing.badge": "Learn a language. Meet the world.",
  "landing.h1a": "Talk with native speakers.",
  "landing.h1b": "Leave with a friend for life.",
  "landing.sub": "Match instantly with a native speaker and trade languages with live flashcards during your call.",
  "landing.cta1": "Get started free",
  "landing.cta2": "I have an account",
  "landing.tagline": "A nonprofit making language learning free, human, and open to everyone.",
  "vision.title": "Our Vision",
  "vision.lead": "Imagine a world where no one is excluded because of the language they speak.",
  "vision.p1": "A student in Brazil practices English with a firefighter in Idaho. A refugee gains confidence speaking the language of their new home. A retiree in Japan teaches Japanese while discovering a new friend in Mexico. Complete strangers become teachers, students, mentors, and lifelong friends.",
  "vision.p2": "This is the world we're building.",
  "vision.p3": "SpeakStudio is a nonprofit dedicated to making language learning free, human, and accessible to everyone. We believe every person has something valuable to teach, and every person deserves the opportunity to learn.",
  "vision.p4": "Our mission extends far beyond vocabulary and grammar.",
  "vision.p5": "We believe that every conversation has the power to reduce loneliness, build empathy, break down prejudice, and create opportunities that would never have existed otherwise.",
  "vision.p6": "Every language learned opens doors to education, employment, travel, culture, and friendship.",
  "vision.p7": "Technology has connected billions of devices, yet many people have never felt more disconnected from one another. We want to change that.",
  "vision.p8": "We're creating a global community where people exchange more than words—they exchange perspectives, cultures, experiences, and hope.",
  "vision.p9": "Success for SpeakStudio isn't measured by how many lessons are completed.",
  "vision.p10": "It's measured by the friendships formed, the confidence gained, the opportunities created, and the barriers that disappear when people finally understand one another.",
  "vision.p11": "This isn't another language app.",
  "vision.p12": "It's infrastructure for a more connected world.",
  "vision.p13": "If you believe communication creates understanding, and understanding creates peace, then you're already part of our mission.",
  "vision.cta": "Start Your Journey",
  "landing.nowPracticing": "Now practicing",
  "landing.liveBadge": "Live, not a lesson",
  "landing.howTitle": "How it works",
  "landing.howSub": "Match, hop on a live video call, and learn from each other in real time — the flashcards live right on top of the call.",
  "landing.step1Kicker": "Step 1",
  "landing.step1Title": "Sign up & set your languages",
  "landing.step1Desc": "Create your profile and tell us the language you speak and the one you want to learn.",
  "landing.step2Kicker": "Step 2",
  "landing.step2Title": "Match into a live video call",
  "landing.step2Desc": "One tap pairs you with a native speaker — English ⇄ Spanish — for a real, face-to-face conversation.",
  "landing.step3Kicker": "Step 3",
  "landing.step3Title": "Trade languages & award points",
  "landing.step3Desc": "Flashcards float right over the live video. You each get a card in the other's language — help, correct, and tap Correct to award points as you both improve.",
  "landing.communityH2a": "Most people come to learn.",
  "landing.communityH2b": "They leave with a friend.",
  "landing.communitySub": "Real conversations with real people from around the world. No scripts, no pressure — just human connection.",
  "landing.communityCta": "Join SpeakStudio",
  "landing.iSpeak": "I speak",
  "landing.imLearning": "I'm learning",
  // auth
  "auth.createTitle": "Create your account",
  "auth.welcomeTitle": "Welcome back",
  "auth.createSub": "Join the conversation and make a friend.",
  "auth.welcomeSub": "Log in to keep talking.",
  "auth.name": "Name",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.country": "Country",
  "auth.iSpeak": "I speak",
  "auth.imLearning": "I'm learning",
  "auth.createBtn": "Create account",
  "auth.loginBtn": "Log in",
  "auth.haveAccount": "Already have an account?",
  "auth.newHere": "New to SpeakStudio?",
  "auth.switchLogin": "Log in",
  "auth.switchSignup": "Sign up",
  // dashboard
  "dash.readyBadge": "Ready to talk?",
  "dash.title": "Find a native speaker to practice with",
  "dash.sub": "We'll match you by the language you speak and the one you're learning. Warm up with flashcards, then talk live.",
  "dash.quickMatch": "Quick match",
  "dash.suggested": "Suggested partners",
  "dash.suggestedSub": "People who speak what you're learning.",
  "dash.noPartners": "No matches yet — update your languages in your profile.",
  "dash.finding": "Finding a partner…",
  "dash.findingSub": "Hang tight while we connect you with someone.",
  "dash.cancel": "Cancel",
  // usercard
  "card.speaks": "Speaks",
  "card.learning": "Learning",
  "card.addFriend": "Add friend",
  "card.friends": "Friends",
  "card.requested": "Requested",
  "card.online": "Online",
  "card.offline": "Offline",
  "card.inCall": "In a call",
  // friends
  "friends.title": "Your circle",
  "friends.sub": "The friends you've made along the way.",
  "friends.requests": "Friend requests",
  "friends.friends": "Friends",
  "friends.sent": "Sent requests",
  "friends.accept": "Accept",
  "friends.noFriends": "No friends yet — send a request from the Match page.",
  "friends.noSent": "No pending requests.",
  // flashcards
  "flash.title": "Flashcards",
  "flash.sub": "Warm up before your next conversation. Tap a card to flip it.",
  "flash.term": "Term",
  "flash.meaning": "Meaning",
  "flash.flip": "tap to flip",
  // profile
  "profile.name": "Name",
  "profile.country": "Country",
  "profile.bio": "Bio",
  "profile.bioPlaceholder": "Tell partners about yourself…",
  "profile.iSpeak": "I speak",
  "profile.imLearning": "I'm learning",
  "profile.flashcardLevel": "Challenge Mode",
  "profile.save": "Save changes",
  "profile.saved": "Profile updated",
  // calling
  "card.call": "Call",
  "card.offlineBtn": "Offline",
  "card.inCallBtn": "In a call",
  "call.incomingTitle": "Incoming call",
  "call.isCalling": "is calling you…",
  "call.answer": "Answer",
  "call.decline": "Decline",
  "call.callingTitle": "Calling…",
  "call.ringing": "Ringing…",
  "call.cancel": "Cancel",
  "call.declined": "declined your call",
  "call.noAnswer": "No answer",
  "call.connecting": "Connecting…",
};

// Static Spanish translations (human-quality).
export const es = {
  "nav.match": "Emparejar",
  "nav.friends": "Amigos",
  "nav.flashcards": "Tarjetas",
  "nav.profile": "Perfil",
  "nav.moderation": "Moderación",
  "nav.login": "Iniciar sesión",
  "nav.signup": "Comenzar",
  "nav.points": "pts",
  "landing.badge": "Aprende un idioma. Conoce el mundo.",
  "landing.h1a": "Habla con hablantes nativos.",
  "landing.h1b": "Sal con un amigo para toda la vida.",
  "landing.sub": "Conecta al instante con un hablante nativo e intercambien idiomas con tarjetas en vivo durante la llamada.",
  "landing.cta1": "Empieza gratis",
  "landing.cta2": "Ya tengo una cuenta",
  "landing.tagline": "Una organización sin fines de lucro que hace el aprendizaje de idiomas gratis, humano y abierto a todos.",
  "vision.title": "Nuestra Visión",
  "vision.lead": "Imagina un mundo donde nadie quede excluido por el idioma que habla.",
  "vision.p1": "Un estudiante en Brasil practica inglés con un bombero en Idaho. Un refugiado gana confianza al hablar el idioma de su nuevo hogar. Un jubilado en Japón enseña japonés mientras descubre a un nuevo amigo en México. Personas desconocidas se convierten en maestros, estudiantes, mentores y amigos para toda la vida.",
  "vision.p2": "Este es el mundo que estamos construyendo.",
  "vision.p3": "SpeakStudio es una organización sin fines de lucro dedicada a hacer que el aprendizaje de idiomas sea gratuito, humano y accesible para todos. Creemos que cada persona tiene algo valioso que enseñar, y que cada persona merece la oportunidad de aprender.",
  "vision.p4": "Nuestra misión va mucho más allá del vocabulario y la gramática.",
  "vision.p5": "Creemos que cada conversación tiene el poder de reducir la soledad, construir empatía, derribar prejuicios y crear oportunidades que de otro modo nunca habrían existido.",
  "vision.p6": "Cada idioma que se aprende abre puertas a la educación, el empleo, los viajes, la cultura y la amistad.",
  "vision.p7": "La tecnología ha conectado miles de millones de dispositivos y, sin embargo, muchas personas nunca se han sentido tan desconectadas entre sí. Queremos cambiar eso.",
  "vision.p8": "Estamos creando una comunidad global donde las personas intercambian mucho más que palabras: intercambian perspectivas, culturas, experiencias y esperanza.",
  "vision.p9": "El éxito de SpeakStudio no se mide por cuántas lecciones se completan.",
  "vision.p10": "Se mide por las amistades formadas, la confianza ganada, las oportunidades creadas y las barreras que desaparecen cuando las personas por fin se entienden entre sí.",
  "vision.p11": "Esta no es otra aplicación de idiomas.",
  "vision.p12": "Es la infraestructura para un mundo más conectado.",
  "vision.p13": "Si crees que la comunicación crea entendimiento, y que el entendimiento crea paz, entonces ya formas parte de nuestra misión.",
  "vision.cta": "Comienza tu viaje",
  "landing.nowPracticing": "Practicando ahora",
  "landing.liveBadge": "En vivo, no una clase",
  "landing.howTitle": "Cómo funciona",
  "landing.howSub": "Emparéjate, únete a una videollamada en vivo y aprendan el uno del otro en tiempo real: las tarjetas viven justo encima de la llamada.",
  "landing.step1Kicker": "Paso 1",
  "landing.step1Title": "Regístrate y elige tus idiomas",
  "landing.step1Desc": "Crea tu perfil y dinos el idioma que hablas y el que quieres aprender.",
  "landing.step2Kicker": "Paso 2",
  "landing.step2Title": "Emparéjate en una videollamada en vivo",
  "landing.step2Desc": "Un toque te empareja con un hablante nativo — inglés ⇄ español — para una conversación real, cara a cara.",
  "landing.step3Kicker": "Paso 3",
  "landing.step3Title": "Intercambia idiomas y otorga puntos",
  "landing.step3Desc": "Las tarjetas aparecen sobre el video en vivo. Cada uno recibe una tarjeta en el idioma del otro: ayuda, corrige y toca Correcto para otorgar puntos mientras ambos mejoran.",
  "landing.communityH2a": "La mayoría viene a aprender.",
  "landing.communityH2b": "Se van con un amigo.",
  "landing.communitySub": "Conversaciones reales con personas reales de todo el mundo. Sin guiones, sin presión: solo conexión humana.",
  "landing.communityCta": "Únete a SpeakStudio",
  "landing.iSpeak": "Yo hablo",
  "landing.imLearning": "Estoy aprendiendo",
  "auth.createTitle": "Crea tu cuenta",
  "auth.welcomeTitle": "Bienvenido de nuevo",
  "auth.createSub": "Únete a la conversación y haz un amigo.",
  "auth.welcomeSub": "Inicia sesión para seguir hablando.",
  "auth.name": "Nombre",
  "auth.email": "Correo electrónico",
  "auth.password": "Contraseña",
  "auth.country": "País",
  "auth.iSpeak": "Yo hablo",
  "auth.imLearning": "Estoy aprendiendo",
  "auth.createBtn": "Crear cuenta",
  "auth.loginBtn": "Iniciar sesión",
  "auth.haveAccount": "¿Ya tienes una cuenta?",
  "auth.newHere": "¿Nuevo en SpeakStudio?",
  "auth.switchLogin": "Iniciar sesión",
  "auth.switchSignup": "Regístrate",
  "dash.readyBadge": "¿Listo para hablar?",
  "dash.title": "Encuentra un hablante nativo para practicar",
  "dash.sub": "Te emparejaremos según el idioma que hablas y el que estás aprendiendo. Calienta con tarjetas y luego habla en vivo.",
  "dash.quickMatch": "Emparejar rápido",
  "dash.suggested": "Compañeros sugeridos",
  "dash.suggestedSub": "Personas que hablan lo que estás aprendiendo.",
  "dash.noPartners": "Aún no hay coincidencias: actualiza tus idiomas en tu perfil.",
  "dash.finding": "Buscando un compañero…",
  "dash.findingSub": "Espera un momento mientras te conectamos con alguien.",
  "dash.cancel": "Cancelar",
  "card.speaks": "Habla",
  "card.learning": "Aprende",
  "card.addFriend": "Agregar amigo",
  "card.friends": "Amigos",
  "card.requested": "Solicitado",
  "card.online": "En línea",
  "card.offline": "Desconectado",
  "card.inCall": "En una llamada",
  "friends.title": "Tu círculo",
  "friends.sub": "Los amigos que has hecho en el camino.",
  "friends.requests": "Solicitudes de amistad",
  "friends.friends": "Amigos",
  "friends.sent": "Solicitudes enviadas",
  "friends.accept": "Aceptar",
  "friends.noFriends": "Aún no tienes amigos: envía una solicitud desde la página de Emparejar.",
  "friends.noSent": "No hay solicitudes pendientes.",
  "flash.title": "Tarjetas",
  "flash.sub": "Calienta antes de tu próxima conversación. Toca una tarjeta para voltearla.",
  "flash.term": "Término",
  "flash.meaning": "Significado",
  "flash.flip": "toca para voltear",
  "profile.name": "Nombre",
  "profile.country": "País",
  "profile.bio": "Biografía",
  "profile.bioPlaceholder": "Cuéntales a tus compañeros sobre ti…",
  "profile.iSpeak": "Yo hablo",
  "profile.imLearning": "Estoy aprendiendo",
  "profile.flashcardLevel": "Modo Desafío",
  "profile.save": "Guardar cambios",
  "profile.saved": "Perfil actualizado",
  "card.call": "Llamar",
  "card.offlineBtn": "Desconectado",
  "card.inCallBtn": "En una llamada",
  "call.incomingTitle": "Llamada entrante",
  "call.isCalling": "te está llamando…",
  "call.answer": "Contestar",
  "call.decline": "Rechazar",
  "call.callingTitle": "Llamando…",
  "call.ringing": "Sonando…",
  "call.cancel": "Cancelar",
  "call.declined": "rechazó tu llamada",
  "call.noAnswer": "Sin respuesta",
  "call.connecting": "Conectando…",
};

export const STATIC = { en, es };
